export default [
    {
        path: '/airhome', // 登录
        component: resolve => require(['@/pages/airhome/home'], resolve),
        name: '首页'
    },
    {
        path: '/airgoodDetail/:id', // 商品详情
        component: resolve => require(['@/pages/airhome/goodDetail'], resolve),
        name: '商品详情页'
    },
    {
        path: '/aircart',
        component: resolve => require(['@/pages/airhome/cart'], resolve),
        name: '购物车'
    },
    {
        path: '/airclause',
        component: resolve => require(['@/pages/airhome/clause'], resolve),
        name: '长龙航空会员条款'
    },
    {
        path: '/airfilm/:id',
        component: resolve => require(['@/pages/airhome/film.vue'], resolve)
    },
]



// WEBPACK FOOTER //
// ./src/router/modules/airbus.js